<template>
  <div class="featured-post-component" v-if="post">
    <div class="container">
      <div class="row no-gutters">
        <div class="col-12 col-md-6 blog-section">
          <div class="blog-section-image" :style="backgroundImage(post.image)"></div>
        </div>
        <div class="col-12 col-md-6">
          <div class="blog-section-text text-center my-auto">
            <h2>{{ post.title }}</h2>
            <p>
              <a :href="`/journals/${post.slug}`">
                Read more -
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FeaturedPost",
  props: {
    post: Object
  },
  methods: {
    backgroundImage(imageUrl) {
      return { backgroundImage: `url(${imageUrl})` };
    }
  }
};
</script>

<style lang="sass" scoped>
.featured-post-component
  margin: 10rem auto 0

.blog-section
  height: 450px
  overflow-x: hidden

.blog-section-image
  background-position: center !important
  background-size: cover !important
  height: 100%

.blog-section-text
  background-color: $dutche-primary-yellow
  height: 100%
  color: $white
  padding: 3rem

  h2
    font-size: 4em
    text-align: left
    color: $dutche-primary-violet
    font-family: "Might Could"

  p
    color: $white
    text-align: left

  a, a:hover, a:focus
    text-decoration: none
    color: $dutche-primary-brown

@media (max-width: 575px)
  .featured-post-component
    margin: 4rem auto

@media (max-width: 768px)
  .blog-section-text
    h2
      font-size: 2.2em
      text-align: center
    p
      text-align: center
</style>
